import React, { lazy, Suspense } from "react";
import Backdrop from "components/common-components/backdrop";

const Default = lazy(() => import("../../../../layouts/dashboard/default"));
const EmbeddedSmsCreate = lazy(() =>
  import("../../embedded-tools/pages/embaded-sms-gengerator")
);
const EmbeddedWhatsappCreate = lazy(() =>
  import("../../embedded-tools/pages/embaded-whatsapp-generator")
);
const EmbeddedEmailCreate = lazy(() =>
  import("../../embedded-tools/pages/embedded-email-generator")
);

export const EngagementRouter = [
  {
    path: "embedded-tools",
    element: (
      <Suspense fallback={<Backdrop />}>
        <Default />
      </Suspense>
    ),
    children: [
      {
        path: "create-email",
        element: (
          <Suspense fallback={<Backdrop />}>
            <EmbeddedEmailCreate />
          </Suspense>
        ),
      },
      {
        path: "create-sms",
        element: (
          <Suspense fallback={<Backdrop />}>
            <EmbeddedSmsCreate />
          </Suspense>
        ),
      },
      {
        path: "create-whatsapp",
        element: (
          <Suspense fallback={<Backdrop />}>
            <EmbeddedWhatsappCreate />
          </Suspense>
        ),
      },
    ],
  },
];
